import { render, staticRenderFns } from "./TableListClients.vue?vue&type=template&id=5838f90c&"
import script from "./TableListClients.vue?vue&type=script&lang=js&"
export * from "./TableListClients.vue?vue&type=script&lang=js&"
import style0 from "./TableListClients.vue?vue&type=style&index=0&id=5838f90c&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5838f90c')) {
      api.createRecord('5838f90c', component.options)
    } else {
      api.reload('5838f90c', component.options)
    }
    module.hot.accept("./TableListClients.vue?vue&type=template&id=5838f90c&", function () {
      api.rerender('5838f90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListClients.vue"
export default component.exports